import {
  getUploads,
  getAuthorizedClients,
  getTemplate,
  uploadPointsFile,
  deleteTemplate,
  savePointsUploadFile,
} from "@/api/batch-user-points";
import { UTCToLocale, localeToUTC } from "@/utilities/date.js";

const adminBatchPointUpload = {
  namespaced: true,
  state: () => ({
    AuthorizedClients: [],
    Template: null,
    LastUploads: [],
    FileUploadStatus: "",
  }),
  getters: {
    getAuthorizedClients: (state) => {
      return state.AuthorizedClients;
    },
    getTemplate: (state) => state.Template,
    getFileUploadStatus: (state) => state.FileUploadStatus,
    getLastUploads: (state) => state.LastUploads,
  },
  actions: {
    fetchAuthorizedClients({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getAuthorizedClients(payload)
          .then((AuthorizedClients) => {
            commit("SET_AUTHORIZED_CLIENTS", AuthorizedClients);
          })
          .catch(() => {
            console.log("error occured from batch user upload tool store");
          });
      });
    },
    getUploads({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getUploads(payload)
          .then((data) => {
            // if (data) {
            //   data.result.map((upload) => {
            //     upload.upload_date = UTCToLocale(upload.upload_date);
            //   });
            // }
            resolve(data);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    deleteUpload({ commit }, payload) {
      return deleteTemplate(payload);
    },
    getTemplate({ commit }) {
      return new Promise((resolve, reject) => {
        getTemplate()
          .then((Template) => {
            commit("SET_TEMPLATE", Template);
          })
          .catch(() => {
            console.log("error occured from batch user upload tool store");
          });
      });
    },
    uploadPointsFile({ commit }, payload) {
      commit("SET_FILE_UPLOAD_STATUS", "uploading");
      return new Promise((resolve, reject) => {
        uploadPointsFile(payload.file, payload.allowDups)
          .then((uploadDetails) => {
            commit("ADD_LAST_UPLOAD", {
              file: payload,
              uploadResult: uploadDetails,
              uploadTime: new Date().toLocaleString(),
            });
            resolve(uploadDetails);
          })
          .catch((error) => {
            console.log("error occured from batch user upload tool store");
            commit("SET_FILE_UPLOAD_STATUS", "");
            reject(error);
          });
      });
    },
    updateFileUploadStatus({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_FILE_UPLOAD_STATUS", payload);
      });
    },
    savePointsUploadFile({ commit }, payload) {
      commit("SET_FILE_UPLOAD_STATUS", "saving");
      return new Promise((resolve, reject) => {
        savePointsUploadFile(payload)
          .then((saveResult) => {
            commit("SAVE_UPLOAD", saveResult);
            resolve(saveResult);
          })
          .catch(() => {
            console.log("error occured from batch user upload tool store");
          });
      });
    },
  },

  mutations: {
    SET_AUTHORIZED_CLIENTS: (state, AuthorizedClients) => {
      state.AuthorizedClients =
        AuthorizedClients?.length > 0 ? AuthorizedClients : [];
    },
    SET_TEMPLATE: (state, Template) => {
      state.Template = Template;
    },
    SET_FILE_UPLOAD_STATUS: (state, status) => {
      state.FileUploadStatus = status;
    },
    ADD_LAST_UPLOAD: (state, upload) => {
      state.LastUploads = [...state.LastUploads, upload];
      state.FileUploadStatus = "uploaded";
    },
    SAVE_UPLOAD: (state, saveResult) => {
      state.FileUploadStatus = "saved";
      state.LastUploads.at(-1).saveResult = saveResult;
      state.LastUploads.at(-1).saveTime = new Date().toLocaleDateString();
    },
  },
};

export default adminBatchPointUpload;
